import { Image } from 'expo-image';
import React from 'react';
import { View } from 'react-native';

export interface UnitReservedConfettiIconProps {
  size?: number;
}

/**
 * Animated confetti / party popper for Unit Reserved success dialog.
 * Source: assets/images/gif/unit-reserved-confetti.gif
 */
export function UnitReservedConfettiIcon({
  size = 80,
}: Readonly<UnitReservedConfettiIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Image
        source={require('@assets/images/gif/unit-reserved-confetti.gif')}
        style={{ width: size, height: size }}
        contentFit="contain"
      />
    </View>
  );
}

export default UnitReservedConfettiIcon;
